import { computed } from 'vue';

const DEFAULT_LEADSTER_BASE_URL = 'https://app.leadster.com.br/';

export function useLeadsterUrls() {
  const leadsterBaseUrl = computed(
    () => import.meta.env.VITE_LEADSTER_APP_URL || DEFAULT_LEADSTER_BASE_URL
  );

  const buildLeadsterUrl = (path, fallback) => {
    try {
      return new URL(path, leadsterBaseUrl.value).toString();
    } catch {
      return fallback;
    }
  };

  const scriptsUrl = computed(() =>
    buildLeadsterUrl('/scripts', `${DEFAULT_LEADSTER_BASE_URL}scripts`)
  );
  const leadsterAiUrl = computed(() =>
    buildLeadsterUrl('/ai/leadster', `${DEFAULT_LEADSTER_BASE_URL}ai/leadster`)
  );
  const leadsDashboardUrl = computed(() =>
    buildLeadsterUrl('/', DEFAULT_LEADSTER_BASE_URL)
  );
  const leadsUrl = computed(() =>
    buildLeadsterUrl('/leads', `${DEFAULT_LEADSTER_BASE_URL}leads`)
  );
  const marketingIntegrationsUrl = computed(() =>
    buildLeadsterUrl(
      '/integrations',
      `${DEFAULT_LEADSTER_BASE_URL}integrations`
    )
  );
  const scriptsAppLabel = computed(() => {
    try {
      return new URL(leadsterBaseUrl.value).host;
    } catch {
      return 'app.leadster.com.br';
    }
  });

  return {
    leadsterBaseUrl,
    scriptsUrl,
    leadsterAiUrl,
    leadsDashboardUrl,
    leadsUrl,
    marketingIntegrationsUrl,
    scriptsAppLabel,
  };
}
